import { c as _c } from "react/compiler-runtime";
interface Props {
  children: React.ReactNode[];
}
export default function ChatItemContainer(props) {
  const $ = _c(2);
  const {
    children
  } = props;
  let t0;
  if ($[0] !== children) {
    t0 = <>{children}</>;
    $[0] = children;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}